import baseApi from "./base.api"
import { BackgroundBannerType } from '@/types/types'

export const customizationBackgroundBannerService = {
  ...baseApi,
  resource: 'PersonalizacaoFundoBanner',

  save: (data: BackgroundBannerType) => {
    return baseApi.post<BackgroundBannerType>(`${customizationBackgroundBannerService.resource}`, data)
      .then(res => ({
        ...res,
        data: res.data,
      }))
      .catch(error => {
        throw error
      })
  },

  update: (id: string, data: BackgroundBannerType) => {
    return baseApi.put<BackgroundBannerType>(`${customizationBackgroundBannerService.resource}/${id}`, data)
      .then(res => ({
        ...res,
        data: res.data,
      }))
      .catch(error => {
        throw error
      })
  },
  
  getAll: (opt?: { id?: string, ativo?: boolean, planoDeFundoId?: string, bannerId?: string, page?: number, size?: number }) => {
    return baseApi.get<BackgroundBannerType[]>(`${customizationBackgroundBannerService.resource}`, opt)
      .then(res => ({
        ...res,
        data: res.data,
      }))
      .catch(error => {
        throw error
      })
  },

  delete: ({ id } : { id: string }) => {
    return baseApi.delete(`${customizationBackgroundBannerService.resource}/${id}`)
  },

  deleteMany: (ids: string[]) => {
    return ids.map(id => customizationBackgroundBannerService.delete({ id }))
  },

  bulkReplication: (contractIds: string[], data: BackgroundBannerType[]) => {
    const payload = { contratoIds: contractIds, personalizacao: data }

    return baseApi.post(`${customizationBackgroundBannerService.resource}/BulkReplication`, payload)
      .then(res => ({
        ...res,
        data: res.data,
      }))
      .catch(error => {
        throw error
      })
  },
}